import { render, staticRenderFns } from "./dual-select.vue?vue&type=template&id=078321e8"
import script from "./dual-select.vue?vue&type=script&lang=js"
export * from "./dual-select.vue?vue&type=script&lang=js"
import style0 from "./dual-select.vue?vue&type=style&index=0&id=078321e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports